/*
  IBO custom (see theme/CUSTOMIZATIONS.md), 2026-09-30: phone product-page CLS fix.

  Canopy's related-products section (<product-recommendations data-url="...intent=related">) is empty in the page
  HTML and fetches its cards when it comes within 500 px of the viewport (main.js ProductRecommendations). On a fast
  swipe the footer is already on screen when ~381 px of cards arrive, so the footer jumps (CLS 0.18-0.45 at 375 px).
  assets/ibo.css reserves the row's height on phones while the section is pending (no data-ibo-recs attribute).
  This file only reports the outcome, it never changes Canopy's fetch:
    data-ibo-recs="loaded"  as soon as Canopy inserts the cards (reserve dropped, natural height);
    data-ibo-recs="empty"   when Shopify's response had no cards, or nothing arrived 8 s after the section came near
                            the viewport (network error) - the section then collapses instead of leaving a gap.
*/
(function () {
  var SEL = '.cc-product-recommendations > product-recommendations[data-url*="intent=related"]';
  function setup(el) {
    if (el.hasAttribute('data-ibo-recs')) return;
    function has() { return !!el.querySelector('li, .card'); }
    // "loaded" always wins: cards that arrive after an "empty" decision (very slow phone) still show.
    function mark(state) { if (state === 'loaded' || !el.hasAttribute('data-ibo-recs')) el.setAttribute('data-ibo-recs', state); }
    if (has()) { mark('loaded'); return; }

    var mo = new MutationObserver(function () { if (has()) { mark('loaded'); mo.disconnect(); } });
    mo.observe(el, { childList: true, subtree: true });

    // Shopify answered: give Canopy a moment to parse and insert, then decide.
    var m = /section_id=([^&]+)/.exec(el.getAttribute('data-url') || '');
    var key = m ? 'section_id=' + m[1] : 'recommendations/products';
    function onEntry(name) {
      if (name.indexOf('recommendations/products') === -1 || name.indexOf(key) === -1) return;
      setTimeout(function () { if (!has()) mark('empty'); }, 600);
    }
    if ('PerformanceObserver' in window) {
      try {
        new PerformanceObserver(function (list) { list.getEntries().forEach(function (e) { onEntry(e.name); }); })
          .observe({ type: 'resource', buffered: true });
      } catch (e) { /* ignore */ }
    }

    // Safety net (fetch failed, no resource entry): 8 s after the section came near the viewport.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (x) { return x.isIntersecting; })) return;
        io.disconnect();
        setTimeout(function () { if (!has()) mark('empty'); }, 8000);
      }, { rootMargin: '0px 0px 500px 0px' });
      io.observe(el);
    }
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll(SEL), setup); }
  scan();
  // Theme editor re-renders sections.
  document.addEventListener('shopify:section:load', scan);
})();
